import React from 'react';
import { useLocation } from 'react-router-dom';
import PurchaseReturnForm from './PurchaseReturnForm';

const NewPurchaseReturnPage = () => {
    const useQuery = () => new URLSearchParams(useLocation().search);
    const query = useQuery();
    const sourceInvoiceId = query.get('source_invoice_id');

    return (
        <PurchaseReturnForm 
            formType="create" 
            sourceInvoiceId={sourceInvoiceId} 
        />
    );
};

export default NewPurchaseReturnPage;